import React, {useState, useEffect, useRef} from 'react'
import '../css/components/ManageOrder.css';
import Loading from '../general/Loading';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Default from '../assets/default.jpg';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import OrderInvoice from './OrderInvoice';

const ManageOrder = ({setResponse, userData}) => {
            const [loading, setLoading] = useState(false);
            const [searchQuery, setSearchQuery] = useState('');
            const [orders, setOrders] = useState([]);
            const [exchange, setExchange] = useState([]);
            const [showStatus, setShowStatus] = useState(false);
            const [showVerifyStatus, setShowVerifyStatus] = useState(false);
            const [showFree, setShowFree] = useState(false);
            const [selectedOrder, setSelectedOrder] = useState('');
             const [transactionId, setTransactionId] = useState('');
             const [remark, setRemark] = useState('');
             const [charges, setCharges] = useState('');
    const [item, setItem] = useState([]);
    const [productSearch, setProductSearch] = useState('');

    // const [visibleProducts, setVisibleProducts] = useState([]);
    // const [batchIndex, setBatchIndex] = useState(0);
const [freeItems, setFreeItems] = useState([]);
const [showDetail, setShowDetail] = useState(false);
const [showRemark, setShowRemark] = useState(false);
const [showUpdate, setShowUpdate] = useState(false);
const [availableQtys, setAvailableQtys] = useState({});
const [selectedDate, setSelectedDate] = useState(() => {
  const today = new Date().toISOString().split("T")[0];
  return today;
});

const [updateRatesChecked, setUpdateRatesChecked] = useState(false);
const [updatedMrpRates, setUpdatedMrpRates] = useState({});
const [updatedRates, setUpdatedRates] = useState({});


 const navigate = useNavigate();


//  useEffect(() => {
//   if (showUpdate && selectedOrder?.order_items) {
//     const orderItems = JSON.parse(selectedOrder.order_items);

//     // Create an object with index as key and qty as value
//     const initialAvailableQtys = orderItems.reduce((acc, item, idx) => {
// acc[idx] = (item?.avail_qty ?? item.item_qty).toString();
//       return acc;
//     }, {});

//     setAvailableQtys(initialAvailableQtys);
//   }
// }, [showUpdate, selectedOrder]);
useEffect(() => {
  if (showUpdate && selectedOrder?.order_items) {
    const orderItems = JSON.parse(selectedOrder.order_items);

    const initialAvailableQtys = {};
    const initialRates = {}, initialMRP = {};

    orderItems.forEach((item, idx) => {
      initialAvailableQtys[idx] = (item?.avail_qty ?? item.item_qty).toString();

      const tiers = JSON.parse(item.sell_price || "[]");
      const qty = item?.avail_qty ?? item.item_qty;
      const mrp = item.mrp;

      let price = tiers[0]?.price || 0;
      tiers.forEach(t => {
        if (qty >= Number(t.qty)) {
          price = t.price;
        }
      });

      initialRates[idx] = price;
      initialMRP[idx] = mrp;
    });

    setAvailableQtys(initialAvailableQtys);
    setUpdatedRates(initialRates);
    setUpdatedMrpRates(initialMRP);
  }
}, [showUpdate, selectedOrder]);


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };



                // <th class="right">MRP</th>
                    // <td class="right">${item.mrp}</td>



const fetchOrders = async (date) => {
  setLoading(true);

  try {
    const response = await fetch(`https://api.siddhabhairabistore.com/get-dateorders?date=${date}`);
    
    if (response.ok) {
      const data = await response.json();
      const sortedOrders = data.sort(
        (a, b) => new Date(b.order_date) - new Date(a.order_date)
      );
      setOrders(sortedOrders);
    }
  } catch (err) {
    console.error("Error loading:", err);
  } finally {
    setLoading(false);
  }
};

                            const fetchProducts = async () => {

                   const hasSearch = productSearch && productSearch.trim() !== '';
             
    if (!hasSearch) {
    setResponse({ message: 'Enter Item to Search', status: 'error' });

    setTimeout(() => {
      setResponse({ message: '', status: '' });
    }, 2000);

    return;
  }

            setLoading(true);
            try {

                      const params = new URLSearchParams();
params.append('searchQuery', productSearch);

                const response = await fetch(`https://api.siddhabhairabistore.com/get-admin-product?${params.toString()}`);

                if (response.ok) {
                    const data = await response.json();
const filteredData = data.filter(item => item.stock && item.stock !== '0');
                    setItem(filteredData);
                    // setVisibleProducts(data.slice(0, 100));
                    // setBatchIndex(1);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        };


                useEffect(() => {


                            const fetchExchange = async () => {
                        setLoading(true);
                        try {
                            const response = await fetch('https://api.siddhabhairabistore.com/get-exchange');
            
                            if (response.ok) {
                                const data = await response.json();
const sortedExc = data.sort((a, b) => new Date(b.req_on) - new Date(a.req_on));
                                setExchange(sortedExc);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                console.error('Failed to fetch exchange');
                            }
                        } catch (error) {
                            setLoading(false);
                            console.error('Error fetching data:', error);
                        }
                    };

          
        // fetchProducts();
                    fetchOrders(selectedDate);
                    fetchExchange();
                }, []);
            


    const filterOrders = orders.filter(myItem =>
  (myItem.id?.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
  myItem.user_name?.toString().toLowerCase().includes(searchQuery.toLowerCase())
)
);




  const handleShowStatus = (order) => {
    setShowFree(false);
    setShowRemark(false);
    setSelectedOrder(order);
    setShowStatus(true);
  }

    const handleShowFree = (order) => {
    setShowStatus(false);
    setShowRemark(false);
    setSelectedOrder(order);
    setShowFree(true);
  }

    const handleShowDetail = (order) => {
    setShowFree(false);
    setShowStatus(false);
    setShowRemark(false);
    setSelectedOrder(order);
    setShowDetail(true);
  }

      const handleShowVerifyPayment = (order) => {
    setSelectedOrder(order);
    setShowVerifyStatus(true);
  }


  const handleGiveFreeItems = async () => {
  if (!selectedOrder) return;

  const payload = freeItems.map(item => {
    // Determine item_price from sell_price
    const parsedPrices = JSON.parse(item.sell_price || '[]');

    // Find the first matching tier for qty <= item.quantity
    let applicablePrice = parsedPrices.find(p => parseInt(p.qty) >= item.quantity);
    if (!applicablePrice) {
      // fallback to first price if no match
      applicablePrice = parsedPrices[0];
    }

    return {
      id: item.id,
      name: item.name,
      brand: item.brand,
      image: item.image,
      quantity: item.quantity,
      item_price: applicablePrice ? parseFloat(applicablePrice.price) : 0
    };
  });

  try {
    const res = await fetch(`https://api.siddhabhairabistore.com/give-free-item/${selectedOrder.id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: payload })
    });

    if (!res.ok) throw new Error("Failed to give free items");

    const result = await res.json();
                        setResponse({ message: 'Free Items Given Successfully!', status: 'success' });
    setSelectedOrder('');
    setTimeout(() => { setResponse('');}, 2000);

    setShowFree(false);
    setFreeItems([]);
     fetchOrders(selectedDate);
  } catch (error) {
    console.error(error);
  }
};



const handleExchange = (exchangeData, orderData) => {
  navigate('/exchange-detail', { state: { exchanges: exchangeData, order: orderData } });
};


const handleShowRemark = (order) => {
      setSelectedOrder(order);
      setRemark(order.remark || '');
      setCharges(order.charges || '');
          setShowFree(false);
    setShowStatus(false);
  setShowRemark(true);
}



const handleSubmitRemark = async () => {
  // if (!remark.trim()) return;

  setLoading(true);

  try {
    const response = await fetch(`https://api.siddhabhairabistore.com/add-remark/${selectedOrder.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ remark: remark.trim(),
        charges: charges.trim()
       }),
    });

    if (!response.ok) throw new Error('Failed to add remark');

    setResponse({ message: 'Remark/ Charges added successfully!', status: 'success' });
    setRemark('');
    setCharges('')
    setShowRemark(false);
    setTimeout(() => { setResponse(''); }, 2000);
    fetchOrders(selectedDate);

  } catch (error) {
    console.error('Error adding remark:', error);
    setResponse({ message: 'Failed to add remark', status: 'error' });
  } finally {
    setLoading(false);
  }
};


const handleShowUpdate = (order) => {
setShowUpdate(true);
setSelectedOrder(order);
}


const handleUpdateClick = async (updatedItems, total) => {

setLoading(true);

  try {
    const response = await fetch(`https://api.siddhabhairabistore.com/update-avail-item/${selectedOrder.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orderItems: updatedItems, total: total }),
    });

      setLoading(false);
    if (response.ok) {
      // Success feedback
                              setResponse({ message: 'Availability Updated Successfully!', status: 'success' });
    setTimeout(() => { setResponse(''); 
      // window.location.reload()
    }, 2000);

      setShowUpdate(false);
      fetchOrders(selectedDate);
    } else {
      // Error feedback
      const errorData = await response.json();
          setResponse({ message: 'Failed to update', status: 'error' });
      // alert(`Error updating availability: ${errorData.message || 'Unknown error'}`);
    }
  } catch (error) {
          setLoading(false);
          console.log(error.message);
  }
};


const handleDeleteFreeItem = async (order, productId) => {
const updatedFreeItems = JSON.parse(order.free_items || "[]")
    .filter(item => item.id !== productId);

  try {
    const response = await fetch(
      `https://api.siddhabhairabistore.com/update-free-items/${order.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          free_items: updatedFreeItems,
        }),
      }
    );

    if (response.ok) {

      setResponse({
        message: "Free item deleted successfully!",
        status: "success",
      });
          setSelectedOrder('');
    setTimeout(() => { setResponse('');}, 2000);
     fetchOrders(selectedDate);


    }
  } catch (error) {
    console.error(error);
  }
};


useEffect(() => {
  const search = productSearch?.trim();

  if (!search || search.length < 3) {
    setItem([]);
    return;
  }

  const timer = setTimeout(() => {
    fetchProducts(productSearch);
  }, 500);

  return () => clearTimeout(timer);
}, [productSearch]);


const updateRates = async (items, total) => {
  try {
    const res = await fetch(
      `https://api.siddhabhairabistore.com/update-item-rates/${selectedOrder.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items, total }),
      }
    );
    if (res.ok) {

      setResponse({
        message: "Item rates updated successfully!",
        status: "success",
      });
          setSelectedOrder('');
          setUpdateRatesChecked(false);
          setShowUpdate(false);
    setTimeout(() => { setResponse('');}, 2000);
     fetchOrders(selectedDate);
    }

  } catch (err) {
    console.error("Rate update failed:", err);
    return false;
  }
};



  const orderItems = React.useMemo(() => {
  return selectedOrder?.order_items
    ? JSON.parse(selectedOrder.order_items)
    : [];
}, [selectedOrder]);

const newTotal = React.useMemo(() => {
  if (!orderItems?.length) return 0;

  return (
    Number(selectedOrder?.charges || 0) +
    orderItems.reduce((acc, item, idx) => {
      const tiers = JSON.parse(item.sell_price || "[]");
      const qty = Number(item.item_qty || 0);
      const availableQty = Number(availableQtys[idx] ?? qty);
let price = tiers[0]?.price || 0;

tiers.forEach(t => {
  if (availableQty >= Number(t.qty)) {
    const overridePrice = updateRatesChecked ? updatedRates[idx] : null;
    price = overridePrice !== null && overridePrice !== undefined
      ? Number(overridePrice)
      : t.price;
  }
});
      return acc + price * availableQty;
    }, 0)
  );
}, [orderItems, availableQtys, selectedOrder?.charges, updatedRates]);


  return (
    <>
              <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Manage Orders</p>
        </div>

                    <div className='d-flex'>

                    <div className='d-flex bg-white rounded-2 py-2 w-100'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search By Order Id"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />                        
                    </div>

                      <input
    type="date"
    className="form-control mx-2"
    style={{ maxWidth: "150px" }}
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
  />

  {/* FILTER BUTTON */}
  <button
    className="btn btn-dark"
    onClick={() => fetchOrders(selectedDate)}
  >
    Filter
  </button>
  </div>

                                  {filterOrders.map(order => {
                                                  const orderItems = JSON.parse(order.order_items);
const myFreeItems = order.free_items ? JSON.parse(order.free_items) : [];
const matchingExchange = exchange.find(e => e.order_id == order.id && e.user_id == order.user_id);
                                  return (
                    <div className='user-area my-2'>

                        <div className='d-md-flex d-sm-flex justify-content-between'>
                        <p className='fw-semibold fs-5'>Order Id #{order.id}</p>
                        <span className='para-text text-muted fw-semibold'>Customer Name: {order.user_name}<br />
                        Mobile No: {order.mobile}</span>
                        </div>
                        
                        <div className='d-md-flex d-sm-flex justify-content-between'>
                          <span className='d-flex'>
                        <p className='order-span my-1 me-2'>{order.order_status}</p>
                          {matchingExchange && (
                                                    <p className='order-span my-1 cursor-pointer' onClick={() =>  handleExchange(
        exchange.filter(e => e.order_id == order.id && e.user_id == order.user_id), order
      )}>Return/ Exchange</p>
  )}</span>
                        <span className='para-text text-muted fw-semibold'>{order.payment_mode}: ₹{Math.round(Number(order.total_amount) + Number(order.charges))}</span>
                        </div>
                        {/* flex ends */}
                        <p className='para-text fw-semibold my-2'>Order On: {formatDateTime(order.order_date)}</p>

                                            <Swiper spaceBetween={20} slidesPerView={12} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 4,
                        },
                        768: {
                          slidesPerView: 8,
                        },
                        992: {
                          slidesPerView: 10,
                          1200: {
                            slidesPerView: 12,
                          }
                        }
                      }}>
                      {orderItems.length > 0 ? (
                        orderItems.map((item, index) => (
                          <>
                            <SwiperSlide key={index} className='my-2'>
                              <img
                                src={item.image
                                  ? `https://api.siddhabhairabistore.com/uploads/${item.image.split(',')[0]}`
                                  : Default}
                                className='img-fluid rounded'
                                alt='Order'
                              />
                              {/* <p className='my-0 para-text'>{item.name}</p> */}
                              {/* <span className='text-muted para-text'>{item.quantity} Item</span> */}

                            </SwiperSlide>
                          </>
                        ))
                      ) : (
                        <p>No items in this order</p>
                      )}
                    </Swiper>

<p className='text-muted para-text fw-semibold my-0 text-capitalize'>Payment Status: {order.payment_status} &nbsp;&nbsp;
  {order.payment_mode == 'Online Payment' &&<span className='order-span py-2 cursor-pointer' onClick={() => handleShowVerifyPayment(order)}>Verify Status</span>}
<br />
 {matchingExchange && (
    <>
      Request Type: {matchingExchange.req_type} | Status: {matchingExchange.req_status}
    </>
  )}</p>
{order.delivery_date != null ?
                       <p className='para-text fw-semibold my-0'>Delivered On: {formatDateTime(order.delivery_date)}</p>
: ''}
 
<hr />

{myFreeItems.length > 0 ?
<p className='para-text fw-semibold mt-2 mb-0'>Given Free Gifts 🎁 Worth ₹{myFreeItems.reduce((sum, item) => {
        const itemPrice = parseFloat(item.item_price) || 0;
        const quantity = parseInt(item.quantity) || 1;
        return sum + itemPrice * quantity;
      }, 0).toFixed(2)}</p>
: ''}

<div className='row'>
{myFreeItems.length > 0 ? (
myFreeItems.map((item, index) => (
    <>
<div key={index} className='col-lg-1 col-md-2 col-sm-2 col-3 my-2'>
<p
 className='text-danger fs-5 my-0'
  onClick={() => {handleDeleteFreeItem(order, item.id)}}
>
<i class="fa-solid fa-delete-left cursor-pointer"></i></p>
                              <img
                                src={item.image
                                  ? `https://api.siddhabhairabistore.com/uploads/${item.image.split(',')[0]}`
                                  : Default}
                                className='img-fluid rounded'
                                alt='Order'
                              />
                              <p className='mt-1 mb-0 fw-semibold text-muted para-text'>{item.name}</p>
                              {/* <span className='text-muted para-text'>{item.quantity} Item</span> */}
                            </div>
    </>
))
): (
    <p className='text-danger para-text fw-semibold'>No Free Gifts in this order 🙁</p>
)}
</div>
{/* row ends */}

<div className='d-md-flex justify-content-end'>

<button className='order-btn me-2' onClick={() => handleShowUpdate(order)}>Update Order</button>

<button className='order-btn me-2' onClick={() => handleShowRemark(order)}>Charges & Remark</button>

<button className='order-btn me-2' onClick={() => handleShowFree(order)}>Free Item</button>

{order.order_status != 'Cancelled' ? 
<button className='order-btn me-2' onClick={() => handleShowStatus(order)}>Status Update</button>
 : <>&nbsp;&nbsp;</>}
<button className='order-btn' onClick={() => handleShowDetail(order)}>Order Details</button>
</div>


{showRemark && selectedOrder && selectedOrder.id === order.id && (
  <div className="mt-3">

                                <div className="col-md-6 mb-2">
                        <label htmlFor="category" className="profile-label">Extra Charges</label>

    <input
      type="text"
      className="product-control"
      value={charges}
      onChange={(e) => setCharges(e.target.value)}
      placeholder="Enter extra charges on Bill"
    />
    </div>

                                <div className="col-md-6 mb-2">
                        <label htmlFor="category" className="profile-label">Remark</label>

    <textarea
      type="text"
      rows={4}
      className="product-control"
      value={remark}
      onChange={(e) => setRemark(e.target.value)}
      placeholder="Write your remark here"
    />
    </div>


    <button
      className="edit-btn mt-2"
      onClick={handleSubmitRemark}
// disabled={!remark.trim() && !charges.trim()}
>
      Submit
    </button>
  </div>
)}


{showFree && selectedOrder && selectedOrder.id == order.id && (
  <div className="mt-3">
    <label className="profile-label mb-2">Search & Select Items</label>

    <div className="mb-2">
      <Select
        className="basic-single"
        classNamePrefix="select"
        placeholder="Select Item"
        options={item.map(product => ({
          value: product.id,
          label: product.name
        }))}
       onInputChange={(inputValue, { action }) => {
  if (action === "input-change") {
    setProductSearch(inputValue);
  }
}}
        onChange={(selectedOption) => {
           if (!selectedOption) return;

          const selectedProduct = item.find(
            (p) => p.id === selectedOption.value
          );
          if (selectedProduct && !freeItems.some(item => item.id === selectedProduct.id)) {
            setFreeItems([...freeItems, { ...selectedProduct, quantity: 1 }]);
          }
        }}
        isClearable
      />
    </div>

    {freeItems.length > 0 && (
      <div className="mt-3">
        <p className="fw-bold mb-2">Selected Items:</p>
        {freeItems.map((item, index) => (
          <div key={index} className="d-flex align-items-center mb-2">
            <img
              src={
                item.image
                  ? `https://api.siddhabhairabistore.com/uploads/${item.image.split(',')[0]}`
                  : Default
              }
              alt={item.name}
              style={{ width: 45, height: 45, objectFit: 'cover' }}
              className="rounded me-2"
            />
            <span className="para-text col-lg-2 col-md-3 col-sm-4 col-6">{item.brand}<br />{item.name}</span>
<input
  type="number"
  min="1"
  value={item.quantity}
  onChange={(e) => {
    let newQty = parseInt(e.target.value);

    // Find the product stock from visibleProducts by id
    const productStock = item.find(p => p.id === item.id)?.stock || 0;

    if (newQty > productStock) {
      newQty = productStock;
    } else if (newQty < 1) {
      newQty = 1;
    }

    setFreeItems(freeItems.map((prod, i) =>
      i === index ? { ...prod, quantity: newQty } : prod
    ));
  }}
  className="product-control col-lg-1 col-2 me-2"
/>

            <button
              className="border-0 bg-white"
              onClick={() =>
                setFreeItems(freeItems.filter((_, i) => i !== index))
              }
            >
              <i className="fa-solid fa-circle-xmark text-danger fs-4"></i>
            </button>
          </div>
        ))}
      </div>
    )}

        <button
      className="edit-btn mt-2" onClick={handleGiveFreeItems}>Give Free Item</button>
  </div>
)}


{showStatus && selectedOrder && selectedOrder.id == order.id && (
  <div className="mt-3">
    {/* <p className="fw-bold">Update Order Status</p> */}
    
    <div className="mb-2">
      <label className="profile-label mb-2">Select Order Status</label>
      <select
        className="product-control"
        value={selectedOrder.status || ''}
        onChange={(e) =>
          setSelectedOrder({ ...selectedOrder, status: e.target.value })
        }
      >
        <option value="">-- Choose Status --</option>
        <option value="Confirmed">Confirmed</option>
        <option value="Processing">Processing</option>
        <option value="Shipped">Shipped</option>
        <option value="Out for Delivery">Out for Delivery</option>
        <option value="Delivered">Delivered</option>
        <option value="Cancelled">Cancelled</option>
      </select>
    </div>

    {selectedOrder.status === 'Delivered' && (
      <div className="mb-2">
        <label className="profile-label">Delivery Date:</label>
        <input
          type="datetime-local"
          className="product-control"
          value={selectedOrder.delivery_date || ''}
          onChange={(e) =>
            setSelectedOrder({ ...selectedOrder, delivery_date: e.target.value })
          }
        />
      </div>
    )}

    <button
      className="edit-btn mt-2"
      onClick={async () => {
        try {
          const response = await fetch(
            `https://api.siddhabhairabistore.com/update-status/${selectedOrder.id}`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                status: selectedOrder.status, 
                payment_status: selectedOrder.payment_status,
                user_name: selectedOrder.user_name,
                user_mobile: selectedOrder.mobile,
                delivery_date:
                  selectedOrder.status == 'Delivered'
                    ? selectedOrder.delivery_date
                    : null,
              }),
            }
          );

          if (response.ok) {
            const updatedOrders = orders.map((order) =>
    order.id === selectedOrder.id
      ? {
          ...order,
          order_status: selectedOrder.status,
          delivery_date: selectedOrder.status == 'Delivered' ? selectedOrder.delivery_date : null,
          payment_status: selectedOrder.status == 'Delivered' ? 'Success' : selectedOrder.payment_status
        }
      : order
  );

  setOrders(updatedOrders);
                    setResponse({ message: 'Order Status updated successfully', status: 'success' });
            setShowStatus(false);
    setSelectedOrder('');
    setTimeout(() => setResponse(''), 2000);
          } else {
                    setResponse({ message: 'Something Went Wrong. Try Again Later', status: 'error' });
    setSelectedOrder('');
    setTimeout(() => setResponse(''), 2000);
          }
        } catch (err) {
          console.error('Status update error:', err);
        }
      }}
    >
      Update Status
    </button>
  </div>
)}

                    </div>
                    
                                  )})}

</div>
</section>


{showDetail && 
<OrderInvoice
setShowDetail={setShowDetail} selectedOrder={selectedOrder} userData={userData} />
}


{showVerifyStatus && (
  <>
                  <section className='detail-dialog'>
                    <div className='detail-dialog-inner col-lg-5 animate__animated animate__zoomIn rounded mx-auto px-lg-5 py-lg-5 px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>

                        <p className='page-title'>Verify Online Payment</p>

           <div className="col-12 my-4">
                            <label htmlFor="stock" className="profile-label">Transaction Id</label>
<input
          type="text"
          placeholder="Enter Transaction ID"
                                className="product-control"
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
        />
        </div>


                        <button className='edit-btn'       onClick={async () => {
        try {
          const response = await fetch(
            `https://api.siddhabhairabistore.com/update-payment-status/${selectedOrder.id}`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                status: 'Success',
                payment_id: transactionId,
              }),
            }
          );

          if (response.ok) {
            const updatedOrders = orders.map((order) =>
    order.id === selectedOrder.id
      ? {
          ...order,
          payment_status: 'Success',
          payment_id: transactionId,
        }
      : order
  );

  setOrders(updatedOrders);
                    setResponse({ message: 'Payment Status updated successfully', status: 'success' });
            setShowVerifyStatus(false);
    setSelectedOrder('');
    setTransactionId('');
    setTimeout(() => setResponse(''), 2000);
          } else {
                    setResponse({ message: 'Something Went Wrong. Try Again Later', status: 'error' });
    setSelectedOrder('');
    setTimeout(() => setResponse(''), 2000);
          }
        } catch (err) {
          console.error('Status update error:', err);
        }
      }}>Yes</button>&nbsp;&nbsp;
                        <button className='close-btn' onClick={() => setShowVerifyStatus(false)}>No</button>
</div>
</section>
  </>
)}


{showUpdate && (
  
  <>
                <section className='detail-dialog px-4 py-4 overflow-y-auto'>
                    <div className='detail-dialog-inner col-lg-9 animate__animated animate__zoomIn rounded mx-auto px-3 py-3 text-center' onClick={(e) => e.stopPropagation()}>


<p className='fw-semibold fs-5'>Update Order Id #{selectedOrder.id} as Availability</p>
<div className="mb-3 text-start">
  <label className='fw-semibold'>
    <input
      type="checkbox"
      checked={updateRatesChecked}
      onChange={(e) => setUpdateRatesChecked(e.target.checked)}
    />{" "}
   Check here to Update Rates
  </label>
</div>

<div className='table-responsive my-4'>
<table className='w-100'>

    <tr className='order-tr'>
        <th className='order-th text-start'>S No</th>
        <th className='order-th text-start'>Name</th>
        <th className='order-th text-start'>MRP</th>
        <th className='order-th text-start'>Price</th>
        <th className='order-th text-start'>Qty</th>
        <th className='order-th text-start'>Available</th>
                <th className='order-th text-start'>New MRP</th>

        <th className='order-th text-start'>New Sale Price</th>
    </tr>


{orderItems.map((item, idx) => {
const tiers = JSON.parse(item.sell_price);
              const qty = item.item_qty;

              const availableQty = Number(availableQtys[idx] ?? qty);

              
              let matchedPrice = tiers.reduce((acc, tier) => {
                if (availableQty >= parseInt(tier.qty)) {
                  return parseFloat(tier.price);
                }
                return acc;
              }, parseFloat(tiers[0].price));

              // const subtotal = matchedPrice * availableQty;

              const handleAvailableChange = (e) => {
                const value = e.target.value;

                // if (value === '' || (Number(value) <= qty && Number(value) >= 0)) {
                if (value === '' || (Number(value) >= 0)) {
                  setAvailableQtys(prev => ({ ...prev, [idx]: Number(value) }));
                }
              };


  return (
    <tr key={idx} className='order-tr text-start'>
      <td className='order-td fw-semibold'>{idx + 1}</td>
      <td className='order-td fw-semibold'>
        {item.name}<br />
        <span className='para-text'>{item.brand}</span>
      </td>
      <td className='order-td fw-semibold'>{item.mrp}</td>
      <td className='order-td fw-semibold'>{matchedPrice}</td>
      <td className='order-td fw-semibold'>{qty}</td>

<td className='order-td align-content-center'>
        <input
          type="tel"
          // min="0"
          style={{maxWidth:'90px'}}
          // max={qty}
          value={availableQtys[idx] ?? ''}
          onChange={handleAvailableChange}
          className="product-input"
        />
      </td>
                  <td className='order-td align-content-center'>
  <input
    type="tel"
    // min="0"
              style={{maxWidth:'90px'}}

    value={updatedMrpRates[idx] ?? ''}
    onChange={(e) =>
      setUpdatedMrpRates(prev => ({
        ...prev,
        [idx]: e.target.value
      }))
    }
    className="product-input"
    placeholder="MRP"
    disabled={!updateRatesChecked}
  />
</td>


            <td className='order-td align-content-center'>
  <input
    type="tel"
    // min="0"
              style={{maxWidth:'90px'}}

    value={updatedRates[idx] ?? ''}
    onChange={(e) =>
      setUpdatedRates(prev => ({
        ...prev,
        [idx]: e.target.value
      }))
    }
    className="product-input"
    placeholder="Sale Price"
    disabled={!updateRatesChecked}
  />
</td>



          </tr>
  );

})}


    <tr className='order-tr text-start'>
      <td className='order-td fw-semibold'>Extra Charges: ₹{selectedOrder.charges ?? '0'}</td>
      <td className='order-td fw-semibold'></td>
      <td className='order-td fw-semibold'>Old Total: ₹
        {(Number(selectedOrder.charges || 0) + orderItems.reduce((acc, item) => {
  const tiers = JSON.parse(item.sell_price);
  const qty = item.item_qty;

  const matchedPrice = tiers.reduce((accPrice, tier) => {
    if (qty >= parseInt(tier.qty)) {
      return parseFloat(tier.price);
    }
    return accPrice;
  }, parseFloat(tiers[0].price));

  return acc + (matchedPrice * qty);
}, 0)).toFixed(2)}
      </td>
      <td className='order-td fw-semibold'>New Total: ₹
        {newTotal.toFixed(2)}</td>
</tr>



    </table>
</div>



                        <button className='close-btn' onClick={() => setShowUpdate(false)}>Go Back</button>&nbsp;&nbsp;
                        <button className='edit-btn' onClick={() => {
 const updatedItems = orderItems.map(
    (item, idx) => {
      const tiers = JSON.parse(item.sell_price || "[]");
      const qty = item.item_qty;
      const availableQty = Number(availableQtys[idx] ?? qty);
    const newPrice = updatedRates?.[idx];
    const newMrp = updatedMrpRates?.[idx];

       let updatedTiers = [...tiers];

         if (updateRatesChecked && newPrice) {
      updatedTiers = tiers.map(tier => {
        if (availableQty >= Number(tier.qty)) {
          return {
            ...tier,
            price: Number(newPrice)
          };
        }
        return tier;
      });
    }


      return {
        ...item,
        mrp: newMrp,
        avail_qty: availableQty,
        sell_price: JSON.stringify(updatedTiers) 
      };
    }
  );

const total = updatedItems.reduce((acc, item, idx) => {
  const tiers = JSON.parse(item.sell_price || "[]");
  const availableQty = Number(availableQtys[idx] ?? 0);

  let matchedPrice = tiers.reduce((accPrice, tier) => {
    if (availableQty >= Number(tier.qty)) {
      return Number(tier.price);
    }
    return accPrice;
  }, Number(tiers[0]?.price || 0));

  return acc + matchedPrice * availableQty;
}, 0);

            handleUpdateClick(updatedItems, total);

if(updateRatesChecked)
   updateRates(
    updatedItems.map(({ id, avail_qty, sell_price, mrp }) => ({
      id,
      avail_qty,
      sell_price,
      mrp: Number(mrp || 0)
    }))
  );

          }}>Update</button>



</div>
</section>
  </>
)}


{loading && <Loading setLoading={setLoading} />}



    </>
  )
}

export default ManageOrder
